var __webpack_exports__ = {};
/*!**************************************!*\
  !*** ./src/scripts/grid-switcher.js ***!
  \**************************************/
class gridSwitcher extends HTMLElement {
  constructor() {
    super()
    this.buttonSingle =  this.querySelector('.single-rect');
    this.buttonDouble =  this.querySelector('.double-rect');

    this.buttonSingle.addEventListener(
      'click',
      this.onClickSingle.bind(this)
    );
    this.buttonDouble.addEventListener(
      'click',
      this.onClickDouble.bind(this)
    );
  }

  onClickSingle(event) {
    this.buttonSingle.classList.add('active')
    this.buttonDouble.classList.remove('active')

    document.querySelector('#main-grid').classList.remove('grid-cols-2');
    document.querySelector('.collection--cta').classList.remove('col-span-2');
    document.querySelector('.collection--cta').classList.add('col-span-1');
    document.querySelector('#main-grid').classList.add('grid-cols-1');
  }

  onClickDouble(event) {
    this.buttonSingle.classList.remove('active')
    this.buttonDouble.classList.add('active')

    document.querySelector('#main-grid').classList.add('grid-cols-2');
    document.querySelector('.collection--cta').classList.add('col-span-2');
    document.querySelector('.collection--cta').classList.remove('col-span-1');
    document.querySelector('#main-grid').classList.remove('grid-cols-1');
  }


}
customElements.define('grid-switcher', gridSwitcher)

